import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Waves, Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--bg-app)" }}>
      <div className="w-full max-w-sm sg-card p-6 sm:p-8 sg-fade" data-testid="forgot-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: "var(--accent)" }}>
            <Waves size={22} color="#fff" />
          </div>
          <div className="font-head text-xl font-extrabold">SHADOW GUIDE</div>
        </div>

        {sent ? (
          <div data-testid="forgot-success">
            <MailCheck size={34} style={{ color: "var(--accent)" }} className="mb-3" />
            <h2 className="font-head text-2xl font-bold mb-2">Check your email</h2>
            <p className="text-sm mb-6" style={{ color: "var(--txt2)" }}>
              If an account exists for <b>{email}</b>, we've sent a password reset link. It expires in 60 minutes.
            </p>
            <Link to="/login" className="sg-btn w-full justify-center" data-testid="forgot-back-login"><ArrowLeft size={16} /> Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h2 className="font-head text-2xl font-bold mb-1">Forgot password</h2>
            <p className="text-sm mb-6" style={{ color: "var(--txt2)" }}>Enter your email and we'll send a secure reset link.</p>

            {err && <div className="chip mb-4 w-full justify-center" data-testid="forgot-error"
              style={{ background: "rgba(239,68,68,0.15)", color: "#EF4444", borderColor: "#EF4444" }}>{err}</div>}

            <label className="text-xs uppercase tracking-wider" style={{ color: "var(--txt2)" }}>Email</label>
            <input className="sg-input mt-1 mb-6" type="email" value={email} data-testid="forgot-email"
              onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />

            <button className="sg-btn sg-btn-accent w-full" disabled={busy} data-testid="forgot-submit">
              {busy ? <Loader2 className="animate-spin" size={18} /> : "Send reset link"}
            </button>
            <Link to="/login" className="block text-center text-sm mt-5" style={{ color: "var(--txt2)" }} data-testid="forgot-back">Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
